export default __webpack_public_path__ + "static/media/800da3b0-675f-465f-892d-d76cecbdd5b1.bd36da35.woff2";